import { render, staticRenderFns } from "./order-area-status-badge.vue?vue&type=template&id=c4ec5820&"
import script from "./order-area-status-badge.vue?vue&type=script&lang=js&"
export * from "./order-area-status-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports